import React from 'react'
import styled from 'styled-components'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import IconGrid from './IconGrid'
import Topic from '~shared/Topic'
import Container from '~shared/Container'
import Spacer from '~shared/Spacer'
import Br from '~shared/Br'

const UnstyledBuyAndStore = (props) => (
    <Topic {...props}>
        <Container>
            <Topic.Title $appear>
                Buy and store DATA
            </Topic.Title>
            <Topic.Paragraph $appear>
                DATA is available from a range of centralised and decentralised exchanges.
                <Br tablet desktop />
                You can use any ERC-20 capable Ethereum wallet to manage your tokens.
                <Br tablet desktop />
                Please do your own research and always be careful with your private keys.
            </Topic.Paragraph>
        </Container>
        <Spacer as={IconGrid} head="3.75rem,7rem,10.5rem">
            <IconGrid.GridItem
                name="Binance"
                description="Leading centralised exchange. Not available in the US"
                icon="binance"
                url="https://www.binance.com?ref=IGUXHN0B"
            />
            <IconGrid.GridItem
                name="Uniswap"
                description="Popular and usable DEX on many chains"
                icon="uniswap"
                url="https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0x8f693ca8D21b157107184d29D398A8D082b38b76"
            />
            <IconGrid.GridItem
                name="Matcha"
                description="Popular DEX aggregator from 0x Project team"
                icon="matcha"
                url="https://www.matcha.xyz/markets/1/0x8f693ca8d21b157107184d29d398a8d082b38b76"
            />
            <IconGrid.GridItem
                name="MetaMask"
                description="Daily driver wallet for desktop and mobile"
                icon="metamask"
                url="https://metamask.io/"
            />
            <IconGrid.GridItem
                name="Ledger"
                description="Popular hardware wallet for the best security"
                icon="ledger"
                url="https://www.ledger.com/"
            />
            <IconGrid.GridItem
                name="Gnosis Safe"
                description="Popular multi-sig wallet for holding jointly owned funds"
                icon="gnosis"
                url="https://gnosis-safe.io/"
            />
        </Spacer>
    </Topic>
)

const BuyAndStore = styled(UnstyledBuyAndStore)`
    ${Topic.Title} {
        margin: 0;
        margin-bottom: 1.5rem;
        text-align: left;
        font-size: 1.75rem;
        line-height: 2.5rem;
    }

    ${Topic.Paragraph} {
        font-size: 1rem;
    }

    @media (min-width: ${TABLET}px) {
        ${Topic.Title} {
            margin-bottom: 1.75rem;
            font-size: 2rem;
            text-align: center;
        }

        ${Topic.Paragraph} {
            text-align: center;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Container} {
            padding: 0;
            max-width: 72.5rem;
        }

        ${Topic.Title} {
            margin-bottom: 3.75rem;
            font-size: 2.5rem;
            line-height: 3rem;
        }

        ${Topic.Paragraph} {
            font-size: 1.125rem;
        }
    }
`

export default BuyAndStore
